import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useMediaQuery,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaSpinner } from "react-icons/fa";
import { useRecoilState } from "recoil";
import ListItem from "../../components/ListItem";
import { useDebouncedValue } from "../../hooks/useDebouncedValue";
import { NewsSearch, useGetSearchedNews } from "../../lib/services";
import { selectionAtom } from "../../store/selection.atom";

const Search = ({
  isOpen,
  onClose,
}: {
  onClose: () => void;
  isOpen: boolean;
}) => {
  const [isMedium] = useMediaQuery(["(min-width: 768px)"]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [toShowList, setToShowList] = useState<
    {
      news_id: number;
      news_title: string;
      title: string;
      url: string;
      published_date: string;
      content: string;
      description: string;
    }[]
  >([]);

  const handleSearch = useGetSearchedNews();
  const [value] = useDebouncedValue(search, 500);
  const [, setSelection] = useRecoilState(selectionAtom);

  useEffect(() => {
    if (value) {
      setLoading(true);
      handleSearch(value)
        .then((res) => {
          const data = res.data as NewsSearch;
          setToShowList(data.data);
        })
        .catch((err) => {})
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (isMedium) {
    return (
      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className="text-rss-primary-color">Search</ModalHeader>
          <ModalCloseButton />
          <ModalBody className="custom-scroll flex max-h-[70dvh] min-h-[70dvh] flex-col gap-5 overflow-y-scroll !px-0">
            <div className="px-5">
              <input
                placeholder="Type word to search"
                className="w-full rounded-full border-[1px] border-rss-border px-5 py-[10px]"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="flex h-full flex-1 flex-col">
              {loading ? (
                <div className="flex h-full items-center justify-center">
                  <FaSpinner className="animate-spin duration-300" />
                </div>
              ) : (
                toShowList.map((content, index) => (
                  <ListItem
                    key={index}
                    className="list-none"
                    onClick={() => {
                      setSelection(() => ({
                        blog: content,
                        category: {
                          id: content.news_id,
                          title: content.news_title,
                        },
                      }));
                      onClose();
                    }}
                  >
                    <div className="text-sm leading-[17.5px] text-rss-muted">
                      {new Date(content.published_date).toLocaleDateString()}
                    </div>
                    <h4 className="line-clamp-3 text-sm leading-[17.5px] text-rss-gray">
                      {content.title}
                    </h4>
                  </ListItem>
                ))
              )}
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Drawer
      onClose={onClose}
      isOpen={isOpen}
      size={isMedium ? "sm" : "full"}
      placement={"left"}
    >
      <DrawerOverlay />
      <DrawerContent className="!h-[calc(100dvh-64.8px)] md:!h-full">
        <DrawerCloseButton />
        <DrawerHeader className="text-rss-primary-color">Search</DrawerHeader>
        <DrawerBody className="custom-scroll">
          <div className="pb-5">
            <input
              placeholder="Type word to search"
              className="w-full rounded-full border-[1px] border-rss-border px-5 py-[10px]"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div>
            {loading ? (
              <div className="flex h-full items-center justify-center">
                <FaSpinner className="animate-spin duration-300" />
              </div>
            ) : (
              toShowList.map((content, index) => (
                <ListItem
                  key={index}
                  className="list-none"
                  onClick={() => {
                    setSelection(() => ({
                      blog: content,
                      category: {
                        id: content.news_id,
                        title: content.news_title,
                      },
                    }));
                    onClose();
                  }}
                >
                  <div className="text-sm leading-[17.5px] text-rss-muted">
                    {new Date(content.published_date).toLocaleDateString()}
                  </div>
                  <h4 className="line-clamp-3 text-sm leading-[17.5px] text-rss-gray">
                    {content.title}
                  </h4>
                </ListItem>
              ))
            )}
          </div>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default Search;
